import { FC } from "react";

import {
	EnhancedDropDownRHFWithLabel,
	EnhancedTextAreaFieldRHF,
	LabelPosition,
	RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";
import { Box } from "@mui/material";

interface ITImeSheetCategoryTrackingFieldsPanel {
	selectCategoryDDL:any
}
export const TImeSheetCategoryTrackingFieldsPanel: FC<
	ITImeSheetCategoryTrackingFieldsPanel
> = ({ selectCategoryDDL }) => {
	return (
		<Box sx={{
			"& .dropDownWrapper ":{
				marginBottom :"0px!important"
			}
		}}>
			<EnhancedDropDownRHFWithLabel
				label="Select Category"
				selectName="selectCatgory"
				testId={`select-category`}
				labelPosition={LabelPosition.Top}
				items={selectCategoryDDL ?? []}
				// showEmpty
			/>
		</Box>
	);
};
